import { Erc20Airdrop } from './Erc20Airdrop';
import { Erc20Approvals } from './Erc20Approvals';
import { Erc20MonoTransfers } from './Erc20MonoTransfers';
import { Erc20Transfers } from './Erc20Transfers';
import { MultiBalance } from './MultiBalance';
import { MultiDivider } from './MultiDivider';
import { MultiMultiplier } from './MultiMultiplier';
import { EthTransfers } from './Transfers';
import { MultiAdd } from './MultiAdd';
import { MultiSubtract } from './MultiSubtract';
import { MultiGetOffchainData } from './MultiGetOffchainData';
import { ApprovedSwap } from './ApprovedSwap';
import { UnwrapAndSendEth } from './UnwrapAndSendEth';
var multicallPlugins = [
    Erc20Airdrop,
    Erc20Approvals,
    Erc20MonoTransfers,
    Erc20Transfers,
    EthTransfers,
    MultiBalance,
    MultiDivider,
    MultiMultiplier,
    MultiAdd,
    MultiSubtract,
    MultiGetOffchainData,
    ApprovedSwap,
    UnwrapAndSendEth,
];
export var getMulticallPluginByName = function (_a) {
    var name = _a.name, chainId = _a.chainId;
    var mCallPlugin = multicallPlugins
        .map(function (Plugin) {
        return new Plugin({ chainId: chainId });
    })
        .find(function (mPlugin) {
        return mPlugin.name === name;
    });
    return mCallPlugin;
};
export var getMulticallPlugin = function (_a) {
    var signature = _a.signature, chainId = _a.chainId;
    var mCallPlugin = multicallPlugins
        .map(function (Plugin) {
        return new Plugin({ chainId: chainId });
    })
        .find(function (mPlugin) {
        return mPlugin.methodInterfaceHash === signature;
    });
    return mCallPlugin;
};
export var getMulticallPluginConstructor = function (_a) {
    var _b;
    var signature = _a.signature, chainId = _a.chainId;
    var mCallPlugin = (_b = multicallPlugins
        .map(function (Plugin) {
        return { plugin: new Plugin({ chainId: chainId }), constructor: Plugin };
    })
        .find(function (mPlugin) {
        if (mPlugin.plugin.methodInterfaceHash === signature)
            return true;
        return false;
    })) === null || _b === void 0 ? void 0 : _b.constructor;
    return mCallPlugin;
};
export { createApprovalsPlugin } from './createApprovalsPlugin';
export { Erc20Airdrop } from './Erc20Airdrop';
export { Erc20Approvals } from './Erc20Approvals';
export { Erc20MonoTransfers } from './Erc20MonoTransfers';
export { Erc20Transfers } from './Erc20Transfers';
export * from './generic/createMulticallPlugin';
export { Multicall } from './generic/Multicall';
export { MultiBalance } from './MultiBalance';
export { MultiDivider } from './MultiDivider';
export { MultiMultiplier } from './MultiMultiplier';
export { EthTransfers } from './Transfers';
export { MultiAdd } from './MultiAdd';
export { MultiSubtract } from './MultiSubtract';
export { MultiGetOffchainData } from './MultiGetOffchainData';
export { ApprovedSwap } from './ApprovedSwap';
export { UnwrapAndSendEth } from './UnwrapAndSendEth';
